<script lang="ts" setup>
// -------------------------------
// 🔹 Imports Vue & composables
// -------------------------------

// -------------------------------
// 🔹 Composants
// -------------------------------
import TextInput from '../common/BaseInput.vue';
import BaseButtonPrimary from '../common/BaseButtonPrimary.vue';

// -------------------------------
// 🔹 Refs & données
// -------------------------------
import { idToDelete } from '@/refs/commerce.refs';
import { isGlobalError } from '@/refs/common.refs';
import { isUpdateFromTaxeActivated } from '@/refs/taxe.refs';
import {
  form_currency_Body,
  isAtcivatedWatchCurrency,
  isUpdateFromCurrency,
} from '@/refs/currency.refs';
import { form, isLoaderLoginFormActivated } from '../../refs/login.form.refs';

// -------------------------------
// 🔹 Mutations / services
// -------------------------------
import { TaxeMutation } from '@/mutations/taxe.mutation';
import { CurrencyMutation } from '@/mutations/currency.mutation';

const { handleCreateCurrency, handleUpdateCurrency } = CurrencyMutation();
// -------------------------------
// 🔹 Émission d’événements
// -------------------------------
const emit = defineEmits<{
  (e: 'HandleClose'): void;
}>();

// -------------------------------
// 🔹 Gestion du formulaire
// -------------------------------

/**
 * Soumet le formulaire de création de commerce.
 * Gère les différentes étapes : création du commerce, ajout du contact, ou upload du logo.
 */

const handleCreate = async () => {
  isLoaderLoginFormActivated.value = true;

  try {
    const res = await handleCreateCurrency({
      name: form_currency_Body.name,
      label: form_currency_Body.label,
      description: form_currency_Body.description,
      //   isActive: Boolean(form_currency_Body.isActive),
    });

    if (res) {
      setTimeout(() => {
        isAtcivatedWatchCurrency.value = !isAtcivatedWatchCurrency.value;
        isLoaderLoginFormActivated.value = false;
        handleClose();
      }, 1000);
    }
  } catch (error) {
    isGlobalError.value = true;
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      isGlobalError.value = false;
    }, 1000);
  }
};

const handleUpdate = async () => {
  isLoaderLoginFormActivated.value = true;

  try {
    const res = await handleUpdateCurrency({
      name: form_currency_Body.name,
      description: form_currency_Body.description,
    });

    if (res) {
      setTimeout(() => {
        isAtcivatedWatchCurrency.value = !isAtcivatedWatchCurrency.value;
        isLoaderLoginFormActivated.value = false;
        handleClose();
      }, 1000);
    }
  } catch (error) {
    isGlobalError.value = true;
    setTimeout(() => {
      isLoaderLoginFormActivated.value = false;
      isGlobalError.value = false;
    }, 1000);
  }
};
const handleSubmit = async () => {
  if (isUpdateFromCurrency.value) {
    handleUpdate();
  } else {
    handleCreate();
  }
};

/**
 * Ferme le formulaire et réinitialise l’ID à supprimer.
 */
const handleClose = (): void => {
  isUpdateFromTaxeActivated.value = false;
  idToDelete.value = null;
  emit('HandleClose');
};
</script>

<template>
  <form
    autocomplete="on"
    accept-charset="UTF-8"
    @submit.prevent="handleSubmit"
    class="space-y-6"
  >
    <div class="space-y-[16px]">
      <TextInput
        required="true"
        v-model="form_currency_Body.name"
        name="Entrez le nom de la monnaie"
        placeholder="Entrez le nom de la monnaie(Euro)"
        type="text"
        id="Entrez le nom de la monnaie"
        label="Entrez le nom de la monnaie"
      />

      <TextInput
        v-show="!isUpdateFromCurrency"
        required="true"
        v-model="form_currency_Body.label"
        name="Entrez l'étiquète de la monnaie"
        placeholder="Entrez l'étiquète de la monnaie(EUR)"
        type="text"
        id="Entrez l'étiquète de la monnaie"
        label="Entrez l'étiquète de la monnaie"
      />

      <TextInput
        required="true"
        v-model="form_currency_Body.description"
        name="Entrez la description de la monnaie"
        placeholder="Entrez la description de la monnaie"
        type="text"
        id="Entrez la description de la monnaie"
        label="Entrez la description de la monnaie"
      />

      <!-- <div class="flex flex-col gap-2">
        <label for="taxe" class="text-14px font-tt-medium-Normal leading-normal">
          Veuillez sélectionner son statut
          <span class="text-decroissance text-14px leading-normal">*</span>
        </label>

        <select
          required
          id="taxe"
          name="taxe"
          v-model="form_currency_Body.isActive"
          class="box-border outline-0 rounded-[10px] h-(--input-height) px-3 py-1 border border-border-input focus:border-primary-900 focus:ring-1 focus:ring-primary-900"
        >
          <option value="true">Actif</option>
          <option value="false">Inatif</option>
        </select>
      </div> -->
    </div>

    <div class="invisible h-[50px]" />

    <div class="fixed bottom-0 left-0 w-full bg-white py-6">
      <div class="flex flex-row items-center justify-between gap-8 px-[16px]">
        <div class="w-full">
          <BaseButtonPrimary
            type="submit"
            :isClicked="isLoaderLoginFormActivated"
            :label="isUpdateFromCurrency ? 'Modifier' : 'Enregistrer'"
            style_of_btn="primary_color_of_btn "
            class="w-full text-white"
          />
        </div>

        <div class="w-full" @click="handleClose">
          <BaseButtonPrimary
            type="button"
            label="Annuler"
            style_of_btn="secondary_color_of_btn "
            class="text-grand-text w-full"
          />
        </div>
      </div>
    </div>
  </form>
</template>
